// extracted by mini-css-extract-plugin
export default {"chartHolder":"ChartHolder_chartHolder__4rpDN"};